import styled from "styled-components";

export const ModalWrapper = styled('div')`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
`;

export const Mask = styled('div')`
    position: fixed;
    top: 0;
    left: 0; 
    width: 100%;
    height: 100%;
    z-index: 10;
    background: rgba(0, 0, 0, 0.67);
`;

export const Content = styled('div')`
    ${props => props.position};
    z-index: 11;
`;
